import { Dialog, DialogTitle, IconButton, Slide } from "@mui/material";
import React, { useState } from "react";
import ChatCommunication from "../../../pages/DashboardPages/inboxPages/ChatCommunication";
import { useDispatch, useSelector } from "react-redux";
import { fetchChild } from "../../../redux/slices/MsgSlice";
import { getAllMessages } from "../Data";
import { FadeLoader } from "react-spinners";
import { IoCloseCircleOutline } from "react-icons/io5";

const ChatModal = ({ isOpen, closeModal, ad, homepage }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const [parent, setParent] = useState(null);
  const isAdmin = user && user.Role === "admin";
  const fetchParent = async () => {
    const req = {
      customerId: ad?.createdBy || ad?.vendorId,
      needId: ad?.Id || ad?.id || ad?.post_id,
      createdBy: user?.UserID,
    };
    const response = await getAllMessages(req);
    const filterParent = response.filter((msg) => msg.parentId == 0);
    if (filterParent.length > 0) {
      setParent(filterParent[0]);
    } else {
      setParent(null);
    }
  };
  React.useEffect(() => {
    if (!islogin || !ad) return;
    fetchParent();
  }, [ad]);
  React.useEffect(() => {
    if (!parent) return;
    dispatch(fetchChild(parent?.Id, user.UserID, isAdmin));
  }, [parent]);
  return (
    <>
      <React.Fragment>
        <Dialog
          open={isOpen}
          keepMounted
          onClose={closeModal}
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "90%", sm: "70%", md: "50%" },
              overflow: "auto",
              maxHeight: "650px",
              position: "relative",
            },
          }}
        >
          <IconButton
            edge="end"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
            sx={{
              position: "absolute",
              padding: "6px",
              top: -4,
              right: 6,
              zIndex: 999, // Ensure it's above other elements
            }}
          >
            <IoCloseCircleOutline />
          </IconButton>
          <ChatCommunication
            isMobileView={false}
            onBack={closeModal}
            toggleDrawer={closeModal}
            isChatModal={true}
            isAds={true}
            homepage={homepage}
          />
          {/* )} */}
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default ChatModal;
